import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(private _http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<any>(this.getUserFromLocalStorage());
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  // ✅ Login Method
  login(email: string, password: string) {
    return this._http.post<any>('https://floyeeapi.icodexa.com/api/tenant/login', { email, password }).pipe(
      map(user => {
        if (user && user.accessToken) {
          localStorage.setItem('currentUser', JSON.stringify(user));
          localStorage.setItem('authToken',JSON.stringify(user.accessToken))
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }
  // ✅ verify Otp Method
  VerifyLink(payload:any) {
    return this._http.post<any>('https://floyeeapi.icodexa.com/api/tenant/linkVerification', payload).pipe(
      map(user => {
        if (user && user.accessToken) {
          localStorage.setItem('currentUser', JSON.stringify(user));
          localStorage.setItem('authToken',JSON.stringify(user.accessToken))
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }

  // ✅ Signup Method (New)
  signup(formData: any) {
    return this._http.post<any>('https://floyeeapi.icodexa.com/api/tenant/signup', formData).pipe(
      map(user => {
        if (user && user.data && user.data.tenant) {
          localStorage.setItem('tenantId', JSON.stringify(user.data.tenant.id));
          localStorage.setItem('tenantEmail', JSON.stringify(user.data.tenant.email));
        } else {
          console.warn('Signup response missing data.tenant:', user);
        }
        return user; 
      })
    );
  }

  // ✅ Logout Method
  logout() {
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
  }

  // Helper: Retrieve user from localStorage
  private getUserFromLocalStorage(): any {
    const userData = localStorage.getItem('currentUser');
    return userData ? JSON.parse(userData) : null;
  }

  // Update current user data
  updateCurrentUser(userData: any) {
    const currentUser = this.currentUserSubject.value;
    if (currentUser) {
      const updatedUser = { ...currentUser, ...userData };
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
      this.currentUserSubject.next(updatedUser);
    }
  }
}
